import React, { useState } from 'react'
import '../Css/Business.css';
import food from '../Images/food.png';
import tick from '../Images/checkmarkss.png'
import printer from '../Images/printer.png';
import laptop from '../Images/laptop.png';
import graphic_design from '../Images/graphic-design.png';
import cctv_camera from '../Images/cctv-camera.png';
import networking from '../Images/networking.png';
import hr_line from '../Images/hr_line2.png';
import business_banner from '../Images/banner.png'
import star from '../Images/star.png'
import certified from '../Images/certified.png';
import {LazyShow2, LazyShow3} from './LazyShow';
import { act } from 'react-dom/test-utils';
const Business = () => {
    const [active, setActive]=useState();
    return (
        <div className='business_sec' id='services'>
            <div className='section_heading'>
                <h2>OUR SERVICES</h2>
                <img src={hr_line} />
                {/* <hr className='hr_line'/> */}
            </div>
            <LazyShow2>
                <div className="businesses">
                    <div className={`business_items ${active == 'food' ? 'active food': ''}`} onClick={() => {setActive('food');}}>
                        <img src={food} alt="food" />
                        <h4>Food</h4>
                    </div>
                    <div className={`business_items ${active == 'printer' ? 'active printer': ''}`} onClick={() => setActive('printer')}>
                        <img src={printer} alt="printer" />
                        <h4>Print Mart</h4>
                    </div>
                    <div className={`business_items ${active == 'graphic_design' ? 'active graphic': ''}`} onClick={() => setActive('graphic_design')}>
                        <img src={graphic_design} alt="graphic_design" />
                        <h4>Graphic Designing</h4>
                    </div>
                    <div className={`business_items ${active == 'networking' ? 'active networking': ''}`} onClick={() => setActive('networking')}>
                        <img src={networking} alt="networking" />
                        <h4>Data Storage & Networking</h4>
                    </div>
                    <div className={`business_items ${active == 'laptop' ? 'active laptop': ''}`} onClick={() => setActive('laptop')}>
                        <img src={laptop} alt="laptop" />
                        <h4>Computer & Laptop Repairing</h4>
                    </div>
                    <div className={`business_items ${active == 'cctv_camera' ? 'active cctv_camera': ''}`} onClick={() => setActive('cctv_camera')}>
                        <img src={cctv_camera} alt="cctv_camera" />
                        <h4>CCTV Surveillance Systems</h4>
                    </div>
                </div>
            </LazyShow2>
            <div className='service-detail-wrapper'>
                <div className={`service_detail ${active == 'food' ? 'show food' : ''}`}  >
                    <div className='service-img'>
                        <img src={food}/>
                    </div>
                    <div className='service-text'>
                        <h2>Koyark Spices</h2>
                        <p>Lorem ipsum is placeholder text commonly used in the graphic, print, industries for previewing layouts and visual mockups. Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.</p>
                    </div>
                    <div className='linkToPage'>
                        <button><a href=''>Visit Site</a></button>
                    </div>
                </div>
                <div className={`service_detail ${active == 'printer' ? 'show print' : ''}`} >
                    <div className='service-img'>
                        <img src={printer}/>
                    </div>
                    <div className='service-text'>
                        <h2>Koyark Printing Press</h2>
                        <p>Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing eviewing layouts and visual mockups. Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.</p>
                    </div>
                    <div className='linkToPage'>
                        <button><a href=''>Visit Site</a></button>
                    </div>
                </div>
                <div className={`service_detail ${active == 'graphic_design' ? 'show graphic' : ''}`} >
                    <div className='service-img'>
                        <img src={graphic_design}/>
                    </div>
                    <div className='service-text'>
                        <h2>Koyark Graphics</h2>
                        <p>Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visuaorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.</p>
                    </div>
                    <div className='linkToPage'>
                        <button><a href=''>Visit Site</a></button>
                    </div>
                </div>
                <div className={`service_detail ${active == 'networking' ? 'show networking' : ''}`}>
                    <div className='service-img'>
                        <img src={networking}/>
                    </div>
                    <div className='service-text'>
                        <h2>Koyark Network</h2>
                        <p>Lorem ipsum is placeholder text commonly used print, and publishing industries for previewing layouts and visual mockups. Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.</p>
                    </div>
                    <div className='linkToPage'>
                        <button><a href=''>Visit Site</a></button>
                    </div>
                </div>
                <div className={`service_detail ${active == 'laptop' ? 'show laptop' : ''}`}>
                    <div className='service-img'>
                        <img src={laptop}/>
                    </div>
                    <div className='service-text'>
                        <h2>Koyark Repairing</h2>
                        <p>Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for and visual mockups. Lorem ipsum is placehol commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.</p>
                    </div>
                    <div className='linkToPage'>
                        <button><a href=''>Visit Site</a></button>
                    </div>
                </div>
                <div className={`service_detail ${active == 'cctv_camera' ? 'show cctv' : ''}`} >
                    <div className='service-img'>
                        <img src={cctv_camera}/>
                    </div>
                    <div className='service-text'>
                        <h2>Koyark Surveillance</h2>
                        <p>Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.</p>
                    </div>
                    <div className='linkToPage'>
                        <button><a href=''>Visit Site</a></button>
                    </div>
                </div>
            </div>
            <div className='business_banner'>
                <div className='banner_heading'>
                    <h2>By giving just the finest to you, we are reaching new heights of perfection.</h2>
                    <img src={star} />
                </div>
                <div className='banner_image'>
                    <div className='banner_content'>
                        {/* <img src={logo}/> */}
                        <LazyShow2>
                            <h3><img src={certified} /> Certified Food Products</h3>
                        
                        <div className='banner_item_wrapper'>
                            <ul className='banner_items'>
                                <li><img src={tick} /> Exotic Spices</li>
                                <li><img src={tick} /> Indian Spices</li>
                                <li><img src={tick} /> Raw Spices</li>
                            </ul>
                            <ul className='banner_items'>
                                <li><img src={tick} /> Powdered Spices</li>
                                <li><img src={tick} /> Organic Spices</li>
                                <li><img src={tick} /> Medicinal Herbs</li>
                            </ul>
                        </div>
                        </LazyShow2>
                    </div>
                    <LazyShow3>
                        <img className='banner' src={business_banner} />
                    </LazyShow3>
                </div>
                
            </div>
        </div>
    )
}

export default Business